<template>
    <div>
        <v-autocomplete
                v-model="model"
                :items="data"
                :label="label"
                :loading="loading"
                :search-input.sync="search"
                :return-object="returnObject"
                cache-items
                :rules="rules"
                clearable
                item-value="id"
                item-text="text"
                :multiple="multi"
                color="primary"
                placeholder="Start typing to Search"
        >
            <template
                    slot="selection"
                    slot-scope="data"
            >
                <v-chip
                        :selected="data.selected"
                        close
                        class="chip--select-multi"
                        @input="remove(data.item.id)"
                >
                    <v-avatar>
                        <img :src="api.GET_IMAGE(data.item.profile_image)">
                    </v-avatar>
                    {{ data.item.first_name + " " + data.item.last_name }}
                </v-chip>
            </template>
            <template
                    slot="item"
                    slot-scope="data"
            >
                <v-list-tile-avatar>
                    <img :src="api.GET_IMAGE(data.item.profile_image)">
                </v-list-tile-avatar>
                <v-list-tile-content>
                    <v-list-tile-title
                            v-html="data.item.first_name + ' ' + data.item.last_name"></v-list-tile-title>
                    <v-list-tile-sub-title v-html="data.item.username"></v-list-tile-sub-title>
                </v-list-tile-content>
            </template>
            <v-slide-x-reverse-transition
                    slot="append-outer"
                    mode="out-in"
            >
                <v-icon
                        :key="`icon-${isEditing}`"
                        :color="isEditing ? 'success' : 'info'"
                        @click="isEditing = !isEditing"
                        v-text="isEditing ? 'mdi-check-outline' : 'mdi-circle-edit-outline'"
                ></v-icon>
            </v-slide-x-reverse-transition>
        </v-autocomplete>
    </div>

</template>

<script>
    export default {
        name: "choose-passenger-multi",
        props: {
            label: {},
            value: {},
            url: {
                type: String,
                default() {
                    return this.api.ACTIONS.PASSENGERS
                }
            },
            initialSearchParams: {
                type: URLSearchParams,
                default: () => new URLSearchParams()
            },
            multi: {
                type: Boolean,
                default: true
            },
            returnObject: {
                type: Boolean,
                default: false
            },
            rules: {
                type: Array,
                default: () => []
            }
        },
        mounted() {
            if (this.returnObject && !!this.value) {
                this.data = this.value instanceof Array ? this.value : [this.value];
            }
        },
        data() {
            return {
                isEditing: false,
                loading: false,
                model: this.value,
                search: null,
                data: [],
                cached: []
            }
        }
        ,
        watch: {
            value(val) {
                this.model = val;
                let newData = val;
                if (!(val instanceof Array))
                    newData = [val];

                newData.forEach(x => {
                    if (this.data.find(y => y.id == x.id))
                        return;

                    this.data = [...this.data, x];
                });
            },
            search(val) {
                this.loading = true;
                const params = new URLSearchParams(this.initialSearchParams);
                params.append("search", val);
                this.axios.get(this.url, {params})
                    .then(res => {
                        const {data} = res.data;
                        this.data = data.map(item => ({
                            text: item.first_name + " " + item.last_name + " " + item.username + " " + item.whatsapp_number + " " + item.email,
                            ...item
                        }));
                    })
                    .catch(err => console.log(err))
                    .finally(() => this.loading = false);
            }
            ,
            model(val) {
                this.$emit("input", val);
            }
        }
        ,
        methods: {
            remove(id) {
                this.model = this.model.filter(item => item !== id);
            }
        }
    }
</script>

<style scoped>

</style>